import { createHttpRouteInvoker } from '../../../../../shared/backend/transports/http';
import { backendConfig } from '../config';
import { normalizeApiError } from '../errors';

export const invokeHttpRoute = createHttpRouteInvoker({
  apiBaseUrl: backendConfig.apiBaseUrl,
  getIdToken: async () => undefined,
  normalizeApiError,
});
